import React from 'react'

const UpwardArrowIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="37"
            viewBox="0 0 25 37"
            fill="none"
        >
            <path
                d="M10.7005 6.80635L3.17543 14.3318C2.80779 14.6992 2.37685 14.8778 1.88262 14.8676C1.3884 14.8573 0.957595 14.6686 0.590219 14.3012C0.249446 13.9335 0.073955 13.5026 0.063743 13.0084C0.0535292 12.5141 0.232112 12.0832 0.599489 11.7156L11.2419 1.07316C11.4225 0.892833 11.623 0.761013 11.8433 0.677701C12.0634 0.594389 12.2939 0.552734 12.5347 0.552734C12.7755 0.552734 13.0059 0.594389 13.226 0.677701C13.4464 0.761013 13.6469 0.892833 13.8275 1.07316L24.4792 11.7252C24.8264 12.0725 25 12.4967 25 12.9979C25 13.4991 24.8264 13.9335 24.4792 14.3012C24.1118 14.6686 23.6759 14.8522 23.1714 14.8522C22.667 14.8522 22.231 14.6686 21.8633 14.3012L14.3689 6.80635L14.3689 24.4018C14.3689 24.9164 14.1919 25.3509 13.838 25.7051C13.4838 26.059 13.0493 26.236 12.5347 26.236C12.02 26.236 11.5856 26.059 11.2314 25.7051C10.8775 25.3509 10.7005 24.9164 10.7005 24.4018L10.7005 6.80635Z"
                fill="#9CA3AF"
            />
            <circle
                cx="12.5348"
                cy="29.5942"
                r="1.84284"
                transform="rotate(-180 12.5348 29.5942)"
                fill="#9CA3AF"
            />
            <circle
                cx="12.5348"
                cy="35.1225"
                r="1.84284"
                transform="rotate(-180 12.5348 35.1225)"
                fill="#9CA3AF"
            />
        </svg>)
}

export default UpwardArrowIcon